import { Component } from '@angular/core';
import { HeaderComponent } from '../../layout/header/header.component';
import { NavbarComponent } from '../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../services/core/routelinks.service';


@Component({
  selector: 'app-ivatypes',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent],
  templateUrl: './ivatypes.component.html',
  styleUrl: './ivatypes.component.css'
})
export class IvatypesComponent {

  links: any[] = [];

  constructor(private routelinks: RoutelinksService) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksIVATypes;
  }

} 
